import { CartAddEvent } from '@theme/events';

/* Cart offer upsell: adds a product from the cart drawer and re-renders the drawer. */
if (!window.__coCartOffer) {
  window.__coCartOffer = true;

  document.addEventListener('click', async (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-co-add]') : null;
    if (!button || button.classList.contains('is-loading')) return;
    event.preventDefault();
    button.classList.add('is-loading');

    const sectionIds = [
      ...new Set(
        [...document.querySelectorAll('cart-items-component[data-section-id]')]
          .map((el) => el.dataset.sectionId)
          .filter(Boolean)
      ),
    ];
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(button.dataset.coAdd), quantity: 1 }],
          sections: sectionIds.join(','),
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'Add to cart failed');

      let itemCount;
      const html = data.sections && sectionIds.length ? data.sections[sectionIds[0]] : null;
      if (html) {
        const countEl = new DOMParser().parseFromString(html, 'text/html').querySelector('[ref="cartItemCount"]');
        if (countEl) itemCount = parseInt(countEl.textContent, 10);
      }

      document.dispatchEvent(
        new CartAddEvent({}, 'cart-offer', {
          source: 'cart-offer',
          itemCount,
          variantId: button.dataset.coAdd,
          sections: data.sections,
        })
      );
    } catch (error) {
      console.error(error);
      button.classList.remove('is-loading');
    }
  });
}
